import React, { useEffect, useRef, useState } from "react";

export default function WebCalling({ agentName, onCallDisconnect, roomToken, onCallProcessing }) {
  const [callMuted, setCallMuted] = useState(false);
  const [callTimer, setCallTimer] = useState(null)
  const [showCalling, setShowCalling] = useState(false)
  const hangUpReceivedRef = useRef(false);
  const callTimerStackRef = useRef([]);

  const handleHangupClick = () => {
    const webCallingIframe = document.getElementById("webCallIframe");
    if (webCallingIframe) {
      webCallingIframe.contentWindow.postMessage({ type: "sipHangUp" }, '*');
    }
    setShowCalling(false);
  }
  const handleMuteClick = () => {
    setCallMuted(!callMuted)
    const webCallingIframe = document.getElementById("webCallIframe");
    if (webCallingIframe) {
      webCallingIframe.contentWindow.postMessage({ type: "sipToggleMute" }, '*');
    }
    if (window && window.parent) {
      window.parent.postMessage({ type: "toggleMuteCall", muteCall: !callMuted }, '*')
    }
  }
  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data.type === "callTalkTimer") {
        setCallTimer(event.data.callTalkTimer)
        callTimerStackRef.current.push({ CallTiming: event.data.callTalkTimer, callTimingSentAt: new Date() });
        if (window && window.parent) {
          window.parent.postMessage({ type: "callTimer", callTimer: event.data.callTalkTimer }, '*')
        }
      }
      if (event.data.type === "CallConnected") {
        setCallTimer("00:00:00")
        if (window && window.parent) {
          window.parent.postMessage({ type: "callConnected", callConnected: true }, '*')
        }
      }
      if (event.data.type === "oSipStack") {
        hangUpReceivedRef.current = false;
        setShowCalling(true)
        if (window && window.parent) {
          window.parent.postMessage({ type: "callInitiated", callInitiated: true }, '*')
        }
      }
      if (event.data.message === "HangUp" || event.data.type === "CallHangup") {
        setShowCalling(false)
        if (window && window.parent) {
          window.parent.postMessage({ type: "callDisconnected", callDisconnected: true }, '*')
        }
        if (!hangUpReceivedRef.current) {
          let hangUpObject = {
            content: JSON.stringify({ callDisconnectedAt: new Date(), callProcessing: false })
          };
          onCallDisconnect(hangUpObject, roomToken);
          hangUpReceivedRef.current = true;
        }
        setCallTimer(null);
      }
    };

    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      if (callTimerStackRef.current.length > 0) {
        let callProcessingObj = {
          content: JSON.stringify({ callTimerStack: [...callTimerStackRef.current] })
        };
        onCallProcessing(callProcessingObj, roomToken)
        callTimerStackRef.current = [];
      }
    }, 5000);

    return () => clearInterval(interval);
  }, []);
  return (
    <>
      {showCalling ?
        <div class="phone_window">

          <ul class="action_button">
            <li class="sp user"></li>
            <li class="calling_info text">
              {agentName ? <span>{agentName}</span> : <span>Policybazaar Advisor</span>}
              {callTimer ?
                <span class="calling timer">{callTimer}</span>
                : <span class="calling">Calling
                  <span className="dot-animation"></span>
                </span>}
            </li>
            {/* <li class="sp speaker"></li> */}
            <li class={`sp mute  ${callMuted ? 'active' : ''}`} onClick={() => handleMuteClick()}></li>
            <li class="sp hangup" onClick={() => handleHangupClick()}></li>
          </ul>

        </div>
        : null}
    </>

  );
}
